import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';

interface IMapPreviewProps {
  link: string;
  className?: string;
}

export const MapPreview: React.FC<React.PropsWithChildren<IMapPreviewProps>> = ({ children, className, link }) => {
  const { telemetry } = useApplicationContext();

  React.useEffect(() => {
    if (!link) {
      return;
    }

    telemetry.increment('static-maps.request');

    const image = new Image();

    image.src = link;

    image.onerror = () => {
      telemetry.increment('static-maps.error');
    };
  }, [link, telemetry]);

  return (
    <div style={{ backgroundImage: `url(${link})` }} className={className}>
      {children}
    </div>
  );
};
